import { useState, useEffect, useRef } from "react";

import { api } from "./pureFunctions";

import { MapContainer, TileLayer, useMap, Marker, Popup, Tooltip, SVGOverlay, CircleMarker } from "react-leaflet";
import "./styles/karte.css";
import { MapLibreTileLayer } from "./MapLibreTileLayer";
import L from "leaflet";
import markerA from "./img/marker.webp";
import markerCircle from "./img/roundmarker.png";
import markerPin from "./img/pinMarker.webp";
import { terminArtenEinkauf } from "./globalVariables";
import GetGeoCoords from "./GetGeoCoords";
import { Button } from "react-bootstrap";
import { useConfig } from "./ConfigContext";

const calenderInterval = [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19];

export default function KarteTermine({
   searchCoords,
   myMap,
   setMyMap,
   frameStyle,
   userObjects,
   terminInfos,
   availableUsers,
   calenderday,
   showAlleTage,
   setSelectedTermin,
   selectedTermin,
   terminArten,
   centerPin,
   getUserCalendar,
}) {
   const config = useConfig();
   const [calendar, setCalendar] = useState([]);
   const [selectedCalendarTermin, setSelectedCalendarTermin] = useState();
   const iconA = new L.Icon({
      iconUrl: markerA,
      iconRetinaUrl: markerA,
      popupAnchor: [-0, -0],
      iconSize: [32, 45],
      className: "custommarker",
   });

   const iconB = new L.Icon({
      iconUrl: markerPin,
      popupAnchor: [-0, -0],
      iconSize: [128, 128],
      className: "hue-rotate-240",
   });
   const iconPin = new L.Icon({
      iconUrl: markerPin,
      popupAnchor: [-0, -0],
      iconSize: [128, 128],
   });

   const center = config.standorte.center.coords; //[48.069127679996505, 9.78794715586747];

   return (
      <>
         <div className="mapframe" style={frameStyle}>
            <MapContainer
               center={center ? center : [47.807276048680215, 9.63688394923563]}
               zoom={10.1}
               zoomSnap={0.1}
               wheelPxPerZoomLevel={160}
               zoomControl={false}
               ref={setMyMap}
               scrollWheelZoom={true} /*  attributionControl={false} */
            >
               <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
               {Object.keys(config.standorte).map((item) => (
                  <Marker icon={iconA} position={config.standorte[item].coords}></Marker>
               ))}

               {terminInfos.length > 0 &&
                  terminInfos.map((terminItem, index) => {
                     let longlat = [parseFloat(terminItem?.breitengrad || 0), parseFloat(terminItem?.laengengrad || 0)];
                     if (!terminItem?.breitengrad || isNaN(terminItem.breitengrad) || isNaN(terminItem.laengengrad)) {
                        console.log(terminItem);
                        longlat = [0, 0];
                     }
                     const daysLeft =
                        "custommarker-" + parseInt(Math.round((terminItem.datum - new Date()) / (1000 * 24 * 3600)));

                     let myPathOptions = { color: "black", weight: 0, fillOpacity: 0.01 };
                     let myStyle = {
                        pointerEvents: "none",
                        padding: terminArtenEinkauf.includes(terminItem.type.label) ? "8px 10px" : "4px 8px",
                        borderRadius: terminArtenEinkauf.includes(terminItem.type.label) ? "50px" : "0px",
                        backgroundColor: userObjects[terminItem.benutzer[0].id]
                           ? userObjects[terminItem.benutzer[0].id].color
                           : "#000",
                        boxShadow: selectedTermin == terminItem.terminId ? "0 0 20px 20px #f00" : "",
                        border: terminArtenEinkauf.includes(terminItem.type.label)
                           ? "solid 1px #0006"
                           : `double 6px #0006`,
                     };
                     let showMarker = true;

                     return (
                        <>
                           {showMarker && (
                              <CircleMarker
                                 eventHandlers={{
                                    click: async (e) => {
                                       setCalendar([]);
                                       console.log(terminItem);

                                       console.log(terminItem.terminId);
                                       const newCalendar = await getUserCalendar([terminItem.benutzer[0].id], {
                                          start: new Date(terminItem.datum),
                                          end: new Date(terminItem.datum),
                                       });
                                       console.log(newCalendar);
                                       setCalendar(newCalendar);
                                    },
                                 }}
                                 center={longlat}
                                 radius={20}
                                 pathOptions={myPathOptions}
                              >
                                 <Tooltip
                                    direction="center"
                                    offset={[0, 0]}
                                    opacity={1}
                                    permanent
                                    zIndex={index == 1 ? 1000 : 0}
                                 >
                                    <div
                                       style={{
                                          ...myStyle,
                                       }}
                                    >
                                       {new Intl.DateTimeFormat("de-DE", { weekday: "short" }).format(terminItem.datum)}{" "}
                                       {terminItem.datum.getDate()}. <br />{" "}
                                       {userObjects && userObjects[terminItem.benutzer[0].id] && (
                                          <span>{userObjects[terminItem.benutzer[0].id].Kuerzel}</span>
                                       )}
                                    </div>
                                 </Tooltip>
                                 <Popup offset={[0, -20]}>
                                    <div>
                                       <h5>{terminItem.datum.toLocaleString()}</h5>

                                       <div className="flex-row">
                                          <div className="me-3">
                                             <strong>{terminItem.type.label}</strong>
                                             <br /> {terminItem.benutzer[0].userName}
                                             <br />
                                             {terminItem.strasse} {terminItem.hausnummer} <br /> {terminItem.plz}{" "}
                                             {terminItem.ort} <br />
                                          </div>
                                          {terminItem.objektnr_extern && (
                                             <a
                                                className="btn btn-outline-primary"
                                                href={"/datenblatt?estateid=" + terminItem.estateId}
                                                target="_blank"
                                             >
                                                {terminItem.objektnr_extern} ↗
                                             </a>
                                          )}
                                       </div>

                                       {selectedCalendarTermin && (
                                          <div
                                             style={{ padding: "6px", borderRadius: "10px", border: "dashed 4px #224" }}
                                          >
                                             <strong>{selectedCalendarTermin.type.label}</strong>
                                             <br /> {selectedCalendarTermin.subject}
                                             <br />
                                             {selectedCalendarTermin.location && selectedCalendarTermin.location.value}
                                             <br />
                                             {selectedCalendarTermin.estate && (
                                                <a
                                                   className="btn btn-outline-primary"
                                                   href={"/datenblatt?estateid=" + selectedCalendarTermin.estate.id}
                                                   target="_blank"
                                                >
                                                   ↗
                                                </a>
                                             )}
                                          </div>
                                       )}

                                       <div
                                          className="calender-frame"
                                          style={{
                                             marginTop: "16px",
                                             maxHeight: "200px",
                                             minWidth: "300px",
                                             overflow: "auto",
                                             borderRadius: "10px",
                                          }}
                                       >
                                          <div className="calender-column-single">
                                             {calenderInterval.map((hourItem) => (
                                                <div
                                                   className="time-row"
                                                   style={{
                                                      height: "30px",
                                                   }}
                                                >
                                                   {hourItem}
                                                </div>
                                             ))}
                                          </div>
                                          <div className="calender-column-single">
                                             {calendar &&
                                                calendar.map((calendarItem) => {
                                                   // console.log(calendarItem.elements);
                                                   if (calendarItem.terminId === terminItem.terminId) {
                                                      console.log(calendarItem.terminId);
                                                      console.log(terminItem.terminId);
                                                   }

                                                   const startTime = new Date(calendarItem.elements.date.start);
                                                   const endTime = new Date(calendarItem.elements.date.end);
                                                   const myheight = (endTime - startTime) / 120000;
                                                   const myTop =
                                                      startTime.getHours() * 30 +
                                                      new Date(calendarItem.elements.date.start).getMinutes() -
                                                      6 * 30;

                                                   return (
                                                      <div
                                                         title={
                                                            calendarItem.elements.type.label +
                                                            " | " +
                                                            calendarItem.elements.subject
                                                         }
                                                         className="appointment-row"
                                                         onClick={() => {
                                                            setSelectedCalendarTermin((prev) =>
                                                               (prev && prev.id) === calendarItem.elements.id
                                                                  ? ""
                                                                  : calendarItem.elements,
                                                            );
                                                         }}
                                                         style={{
                                                            height: myheight,
                                                            top: myTop,
                                                            border:
                                                               selectedCalendarTermin &&
                                                               selectedCalendarTermin.id === calendarItem.elements.id
                                                                  ? "dashed 4px #224"
                                                                  : parseInt(calendarItem.id) === terminItem.terminId
                                                                    ? "solid 4px #d00"
                                                                    : "",
                                                         }}
                                                      >
                                                         {startTime.toLocaleTimeString().slice(0, -3)}-
                                                         {endTime.toLocaleTimeString().slice(0, -3)}
                                                      </div>
                                                   );
                                                })}
                                          </div>
                                       </div>
                                    </div>
                                 </Popup>
                              </CircleMarker>
                           )}
                        </>
                     );
                  })}
               {centerPin && <Marker icon={iconPin} position={centerPin}></Marker>}
               {searchCoords && <Marker icon={iconB} position={[searchCoords.lat, searchCoords.lon]}></Marker>}
            </MapContainer>
         </div>
      </>
   );
}
